<template>
    <div v-if="isMobile && !headingCapital" :style="{ background: '#68b6e7 url(' + imageMob + ') no-repeat ' + imagePosition }" class="hero-banner">
        <h1 class="main-heading">{{heading}}</h1>
    </div>
    <div v-if="!isMobile && !headingCapital" :style="{ background: '#68b6e7 url(' + image + ') no-repeat ' + imagePosition }" class="hero-banner">
        <h1 class="main-heading">{{heading}}</h1>
    </div>
    <div v-if="isMobile && headingCapital" :style="{ background: '#68b6e7 url(' + imageMob + ') no-repeat ' + imagePosition }" class="hero-banner border">
        <div class="header-container">
            <h1 class="lowercase-heading">{{heading}}</h1>
            <h2 class="uppercase-heading">{{headingCapital}}</h2>
        </div>
    </div>
    <div v-if="!isMobile && headingCapital" :style="{ background: '#68b6e7 url(' + image + ') no-repeat ' + imagePosition }" class="hero-banner align-right border">
        <div class="header-container">
            <h1 class="lowercase-heading">{{heading}}</h1>
            <h2 class="uppercase-heading">{{headingCapital}}</h2>
        </div>
    </div>
</template>

<script>import script from './HeroBanner';
    export default script;</script>

<style lang="less" scoped>
    @import "./HeroBanner.less";
</style>
